module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_duo_cuad_5.e7cd2f06.png";